import withToggle from './container'
import View from './views'

export { withToggle }

export default View



// WEBPACK FOOTER //
// ./src/ui/show-hide/index.js